module.exports = __webpack_public_path__ + "static/media/contract3.ddc98e47.png";